module.exports = __webpack_public_path__ + "media/packs/images/flags/MG-fadd1fbd9b0827dab9fa450b66a2b43b.png";